<template>
  <div class="card-detection-item">
    <div class="leftname">
      <div class="yuansu"></div>
      {{ label }}
    </div>
    <!-- 1完成 0错误 2 检测中 3待检测-->
    <CloseOutlined
      class="icons"
      :style="{ fontSize: '0.1rem', color: '#dc5a6e' }"
      v-if="status === 0"
    />
    <CheckOutlined
      class="icons"
      :style="{ fontSize: '0.1rem', color: '#74fef5' }"
      v-if="status === 1"
    />
    <a-spin
      class="icons"
      :indicator="indicator"
      style="margin-left: 0.04rem"
      v-if="status === 2"
    />
    <span class="span-text" v-if="status === undefined || status == 3">
      --
    </span>
  </div>
</template>

<script setup>
import { defineProps, h } from "vue";
import {
  CloseOutlined,
  CheckOutlined,
  LoadingOutlined,
} from "@ant-design/icons-vue";

const props = defineProps({
  label: {
    type: String,
    default: "",
  },
  status: {
    type: [Number, undefined],
    default: undefined,
  },
});

const indicator = h(LoadingOutlined, {
  style: {
    fontSize: "20px",
    color: "#fff",
  },
  spin: true,
});
</script>

<style lang="scss" scoped>
.card-detection-item {
  width: 50%;
  display: flex;
  align-items: center;
  gap: 5px;
}
.leftname {
  font-size: 0.08rem;
  color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.yuansu {
  width: 0.0667rem;
  height: 0.0667rem;
  margin-right: 0.03rem;
  background: url("../../../assets/common/yuansu1.png") center/cover no-repeat;
}
.icons {
  font-size: 0.08rem;
  margin-left: 0.1rem !important;
}
.span-text {
  color: white;
  margin-left: 0.12rem;
}
</style>
